import { Modal } from 'antd';
import React from 'react';
import HSButton from '../../../../../common/Button';

interface ConfirmationModalProps {
    title: string;
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
    centered?: boolean;
    className?: string;
    confirmationLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    title,
    open,
    onOk,
    onCancel,
    centered = false,
    className = '',
    confirmationLoading = false,
}) => {
    return (
        <Modal
            title={title}
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
            centered={centered}
            className={`onboarding_NDA_POP ${className}`}
        >
            <p className="text-base WorkSans text-center text-[#20222B]">
                If you change account type, you will have to go through the whole process again. Are you sure you want
                to change Account Type?
            </p>
            <div className="p-2 flex justify-center items-center mt-4 gap-2">
                <HSButton
                    title="Yes"
                    className=" WorkSans onboarding_btn_modal"
                    onClick={onOk}
                    loading={confirmationLoading}
                />
                <HSButton title="No" onClick={onCancel} className=" onboarding_btn_modal_close" />
            </div>
        </Modal>
    );
};

export default ConfirmationModal;
